import { CSSResultGroup, TemplateResult, html } from 'lit';
import { OutlineElement, SlotsController } from '@phase2/outline-core';
import { customElement } from 'lit/decorators.js';
import componentStyles from './outline-file-download.css.lit';

/**
 * The OutlineFileDownload component
 * @element outline-file-download
 * @slot heading - for outline-heading-baseline
 * @slot description - for outline-styled-text-baseline
 * @slot default - for outline-file-links
 */
@customElement('outline-file-download')
export class OutlineFileDownload extends OutlineElement {
  static styles: CSSResultGroup = [componentStyles];
  slots = new SlotsController(this);

  render(): TemplateResult {
    return html` <section class="outline-file-download">
      <div class="outline-file-download--heading">
        ${this.slots.conditionalSlot('heading', false)}
      </div>
      <div class="outline-file-download--description">
        ${this.slots.conditionalSlot('description', false)}
      </div>
      <div class="outline-file-download--files">
        <slot></slot>
      </div>
    </section>`;
  }
}
